import type { ReactNode } from 'react';

export function ConnectionAccountCard({
  title,
  children,
  leading,
  actions,
}: {
  title: string;
  children?: ReactNode;
  leading?: ReactNode;
  actions?: ReactNode;
}) {
  return (
    <li className="flex flex-wrap items-center justify-between gap-3 rounded-xl border border-border bg-surface px-4 py-4">
      <div className="flex min-w-0 flex-1 items-start gap-3">
        {leading ?? <span className="w-4 shrink-0" aria-hidden />}
        <div className="min-w-0">
          <p className="truncate font-medium text-foreground">{title}</p>
          {children}
        </div>
      </div>
      {actions ? <div className="flex shrink-0 items-center gap-3">{actions}</div> : null}
    </li>
  );
}
